import { DeviceResource } from '@/entities/Device/api';
import { Base, DeviceChambersRawResponse, DeviceChambersResponse, DevicesResponseType, Response } from '@/Services/api/methods';

export class Devices extends Base {
    public getAll(query?: {
        page?: number;
        per_page?: number;
        company_id?: number | string;
        store_group_id?: number | string;
        store_id?: number | string;
        sort?: string;
        order_by?: string;
    }) {
        this.setPath('devices');
        if (query) this.setQuery(query);

        return this.getRequest() as Response<DevicesResponseType>;
    }

    public getChambers(id: number) {
        this.setPath('devices');
        this.setId(`${id}/chambers`);

        return this.getRequest() as Response<DeviceChambersResponse>;
    }

    public updateLicenseKey(deviceId: number, key: string, isForcedPending = false): Response<DeviceResource> {
        this.setPath(`devices/${deviceId}/license-key`);

        this.setData({ license_key: key, is_forced_pending: isForcedPending });

        return this.putRequest<DeviceResource>();
    }

    public readChambersFile(deviceId: number, file: File) {
        this.setPath('devices');
        this.setId(`${deviceId}/import-chambers/read`);
        this.setFormData({ file });

        return this.postRequest<DeviceChambersRawResponse>();
    }
}
